var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconFolderFile1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.231 12.435a1 1 0 0 0-.979-1.193H10.424a1 1 0 0 1-.978-.8l-.278-1.391a1 1 0 0 0-.978-.8H1.747a1 1 0 0 0-.978 1.193l2.593 13a1 1 0 0 0 .978.8h15.918a1 1 0 0 0 .978-.8c.411-2.052 1.508-7.575 1.995-10.009ZM4.5 5.25l.02-3.5a1 1 0 0 1 1-1h12.963a1 1 0 0 1 1 1l.02 6.5M7.512 3.742l8.238.008m-3.75 3h3.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconFolderFile1);
export default __webpack_public_path__ + "static/media/streamline-icon-folder-file-1.5cafcfc6.svg";
export { ForwardRef as ReactComponent };